import React, { ReactNode, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { questionGap } from './styledComponents';

const TRANSITION_MS = 250;

const Collapse = styled.div<{ $isExpanded: boolean }>`
  display: grid;
  grid-template-rows: 0fr;
  margin-top: -${questionGap};
  opacity: 0;
  transition:
    grid-template-rows ${TRANSITION_MS}ms ease,
    margin-top ${TRANSITION_MS}ms ease,
    opacity ${TRANSITION_MS}ms ease;

  ${({ $isExpanded }) =>
    $isExpanded &&
    css`
      grid-template-rows: 1fr;
      margin-top: -1rem;
      opacity: 1;
    `}

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const Content = styled.div`
  min-height: 0;
  overflow: hidden;
  padding-left: 1rem;
`;

type Props = {
  isVisible: boolean;
  children: ReactNode;
};

const FollowUpQuestion = ({ isVisible, children }: Props) => {
  const [isMounted, setIsMounted] = useState(isVisible);
  const [isExpanded, setIsExpanded] = useState(isVisible);

  if (isVisible && !isMounted) {
    setIsMounted(true);
  }

  useEffect(() => {
    if (isVisible) {
      let secondFrame = 0;
      const firstFrame = requestAnimationFrame(() => {
        secondFrame = requestAnimationFrame(() => setIsExpanded(true));
      });
      return () => {
        cancelAnimationFrame(firstFrame);
        cancelAnimationFrame(secondFrame);
      };
    }

    setIsExpanded(false);
    const unmountTimeout = setTimeout(() => setIsMounted(false), TRANSITION_MS);
    return () => clearTimeout(unmountTimeout);
  }, [isVisible]);

  if (!isMounted) return null;

  return (
    <Collapse $isExpanded={isExpanded} aria-hidden={!isVisible}>
      <Content>{children}</Content>
    </Collapse>
  );
};

export default FollowUpQuestion;
